exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card{margin:8px;padding:0;background-color:#2c2f35;color:#ddd;display:flex;flex-direction:column;align-items:center;box-shadow:0 4px 5px 0 rgba(0,0,0,.75);border-radius:4px}.card .title{align-self:flex-start;font-weight:bold;font-size:18px;margin-bottom:8px}", ""]);

